export default "__VITE_ASSET__Dmx6K3N8__"